import styled from "styled-components";

export const RegisterWrapper = styled.div`
    height: calc(100vh - 271px);
    form{
        width: 600px;
    }
    .btn-register{
        height: 40px;
    }
`
